import useUiStore from "../store/useUiStore.ts";
import CreateNewProjectModal from "../components/CreateProjectModal/CreateNewProjectModal.tsx";
import type {ICreateNewProjectState} from "../reducers/createNewProjectReducer.ts";

export const useCreateNewProjectModal = () => {
  const {openModal} = useUiStore();

  return (handleCreateProject: (state: ICreateNewProjectState) => Promise<void>) => {
    openModal(
      <CreateNewProjectModal createNewProject={handleCreateProject}/>,
      {
        className: "md:!p-0 overflow-hidden",
        classWrap: "max-w-[48rem] overflow-hidden md:min-h-screen-ios md:rounded-none",
        classButtonClose: "hidden md:block md:absolute md:top-5 md:right-5 dark:fill-n-400",
        classOverlay: "md:bg-n-100",
      }
    );
  };
};
